export default "__VITE_PUBLIC_ASSET__8a44ea22__"